import { Box, Grid, GridItem, Text, Divider, Image, Flex} from "@chakra-ui/react"
import { DraftButton } from "../assets/svgs/Icons"
import draftButton from "../assets/images/draftButton.png"

export const DraftList = () => {
    return (
        <Box margin={"0.3rem"}>
            <Grid templateColumns='repeat(4, 1fr)' marginTop={"2rem"} marginBottom={"1rem"}>
                <GridItem colSpan={1}>


                    <Box
                    marginLeft={"20px"}
                        style={{
                            background: "lightgrey",
                            width: "56px",
                            height: "56px",
                            backgroundSize: "cover",
                            borderRadius: "50%",
                            
                        }}
                        className="img-fluid profile-img-div"
                    ></Box>


                </GridItem>
                <GridItem colSpan={2} paddingLeft={"4px"}>


                    <Text fontSize={"18px"} fontWeight={"500"} color={"brand.blue"} >Sakharam Ghatane</Text>
                    <Text fontSize={"16px"} fontWeight={"300"} color={"brand.blue"}>Osmanabad</Text>



                </GridItem>
                <GridItem colSpan={1} display={"flex"}  alignItems={"center"} justifyContent={"center"}>
                 
                        <Box>
                    <Image src={draftButton} alt='draft_icon' w={"19.2px"} h={"20px"}/>
                    </Box>
                  

                </GridItem>

            </Grid>
            <Divider />


            {/* redundant components */}
            <Grid templateColumns='repeat(4, 1fr)' marginTop={"2rem"} marginBottom={"1rem"}>
                <GridItem colSpan={1}>


                    <Box
                    marginLeft={"20px"}
                        style={{
                            background: "lightgrey",
                            width: "56px",
                            height: "56px",
                            backgroundSize: "cover",
                            borderRadius: "50%",
                            
                        }}
                        className="img-fluid profile-img-div"
                    ></Box>


                </GridItem>
                <GridItem colSpan={2} paddingLeft={"4px"}>


                    <Text fontSize={"18px"} fontWeight={"500"} color={"brand.blue"} >Sakharam Ghatane</Text>
                    <Text fontSize={"16px"} fontWeight={"300"} color={"brand.blue"}>Osmanabad</Text>



                </GridItem>
                <GridItem colSpan={1} display={"flex"}  alignItems={"center"} justifyContent={"center"}>
                 
                        <Box>
                    <Image src={draftButton} alt='draft_icon' w={"19.2px"} h={"20px"}/>
                    </Box>
                  

                </GridItem>

            </Grid>
            <Divider />
            <Grid templateColumns='repeat(4, 1fr)' marginTop={"2rem"} marginBottom={"1rem"}>
                <GridItem colSpan={1}>


                    <Box
                    marginLeft={"20px"}
                        style={{
                            background: "lightgrey",
                            width: "56px",
                            height: "56px",
                            backgroundSize: "cover",
                            borderRadius: "50%",
                            
                        }}
                        className="img-fluid profile-img-div"
                    ></Box>


                </GridItem>
                <GridItem colSpan={2} paddingLeft={"4px"}>


                    <Text fontSize={"18px"} fontWeight={"500"} color={"brand.blue"} >Sakharam Ghatane</Text>
                    <Text fontSize={"16px"} fontWeight={"300"} color={"brand.blue"}>Osmanabad</Text>



                </GridItem>
                <GridItem colSpan={1} display={"flex"}  alignItems={"center"} justifyContent={"center"}>
                 
                        <Box>
                    <Image src={draftButton} alt='draft_icon' w={"19.2px"} h={"20px"}/>
                    </Box>
                  

                </GridItem>

            </Grid>
            <Divider />
            <Grid templateColumns='repeat(4, 1fr)' marginTop={"2rem"} marginBottom={"1rem"}>
                <GridItem colSpan={1}>


                    <Box
                    marginLeft={"20px"}
                        style={{
                            background: "lightgrey",
                            width: "56px",
                            height: "56px",
                            backgroundSize: "cover",
                            borderRadius: "50%",
                            
                        }}
                        className="img-fluid profile-img-div"
                    ></Box>


                </GridItem>
                <GridItem colSpan={2} paddingLeft={"4px"}>


                    <Text fontSize={"18px"} fontWeight={"500"} color={"brand.blue"} >Sakharam Ghatane</Text>
                    <Text fontSize={"16px"} fontWeight={"300"} color={"brand.blue"}>Osmanabad</Text>



                </GridItem>
                <GridItem colSpan={1} display={"flex"}  alignItems={"center"} justifyContent={"center"}>
                 
                        <Box>
                    <Image src={draftButton} alt='draft_icon' w={"19.2px"} h={"20px"}/>
                    </Box>
                  

                </GridItem>

            </Grid>
            <Divider />
        </Box>
    )
}